// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import router from './router'
import auth from './auth'
//import browser from 'browser-detect';
// import Bootstrap from 'vue-strap'

import 'bootstrap/dist/css/bootstrap.css'

// auth.checkAuth()

//const result = browser();
//console.log(result);

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (await auth.checkAuth()) {
      next()
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
})


Vue.config.productionTip = false
Vue.use(Router)
// Vue.use(Bootstrap)

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js